<template>
  <div style="height: 100%;overflow-y: auto !important;display: ">
    <v-container style="margin-top: px;">
      <h2>地域区分の選択</h2>
    </v-container>
    <v-container style="margin-top: -15px;">
      <v-tabs v-model="tab" color="blue" bg-color="white" align-tabs="center">
        <v-tab value="1">都道府県・市町村から選択</v-tab>
        <v-tab value="2">地域区分から選択</v-tab>
      </v-tabs>
      <v-window v-model="tab">
        <v-window-item value="1">
          <v-container style="margin-top: -10px;">
            <div style="display: flex; justify-content: center; padding-top: 10px;">
              <div style="display: flex; align-items: center; max-width: 650px; width: 100%;">
                <div style="margin-right: 10px; white-space: nowrap; text-align: right; width: 80px;margin-top: -20px;">
                  都道府県&nbsp;
                </div>
                <v-sheet style="width: 450px;">
                  <v-select
                    variant="outlined"
                    density="compact"
                    color="blue"
                    :items="regionList"
                    v-model="regionId"
                    @update:modelValue="prefChange()"
                    required
                  />
                </v-sheet>
              </div>
            </div>
            <div v-if="regionId !== ''" style="display: flex; justify-content: center; padding-top: 10px;">
              <div style="display: flex; align-items: center; max-width: 650px; width: 100%;">
                <div style="margin-right: 10px; white-space: nowrap; text-align: right; width: 80px;margin-top: -20px;">
                  市町村&nbsp;
                </div>
                <v-sheet style="width: 450px;">
                  <v-select
                    variant="outlined"
                    density="compact"
                    color="blue"
                    :items="cityList"
                    v-model="cityId"
                    @update:modelValue="cityChange()"
                    required
                  />
                </v-sheet>
              </div>
            </div>
            <div v-if="cityId !== ''" style="display: flex; justify-content: center; padding-top: 10px;">
              <div style="display: flex; align-items: center; max-width: 650px; width: 100%;">
                <div style="margin-right: 10px; white-space: nowrap; text-align: right; width: 80px; line-height: 1.5; padding-top: 0;">
                  地域&nbsp;
                </div>
                <div style="margin-right: 10px; white-space: nowrap; text-align: right; width: 120px; line-height: 1.5; padding-top: 0;">
                  <span style="font-size: 28px; font-weight: bold; vertical-align: baseline;">{{ rigionClass }}</span>&nbsp;地域
                </div>
              </div>
            </div>
          </v-container>
        </v-window-item>
        <v-window-item value="2">
          <v-container style="margin-top: -10px;">
            <div style="display: flex; justify-content: center;margin-top: 5px;">
              <div style="display: flex; align-items: center; max-width: 650px; width: 100%;">
                <div style="margin-right: 10px; white-space: nowrap; text-align: right; width: 80px;margin-top: -20px;">
                  地域区分&nbsp;
                </div>
                <v-sheet style="margin-left: 5px;width:450px;">
                  <v-select variant="outlined" density="compact" color="blue"
                      :items="rigionData"
                      v-model="rigionClass"
                      required
                      :menu-props="{ maxHeight: '384px' }">
                  </v-select>
                </v-sheet>
              </div>
            </div>
          </v-container>
        </v-window-item>
      </v-window>
    </v-container>
    <v-container style="margin-top: -20px;">
      <v-btn @click="backFnc" color="grey darken-2">
        戻る
      </v-btn>
      &nbsp;&nbsp;
      <v-btn :disabled="!rigionClass" @click="next" color="blue">
        商品の選択へ進む
      </v-btn>
    </v-container>
  </div>
</template>
<script>
import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
export default {
  data () {
    return {
      tab: null,
      regionList: [],
      regionId: '', // 省エネ地域
      cityData: [],
      cityList: [],
      cityId: '',
      rigionData: [],
      rigionClass: ''
    }
  },
  mounted () {
    // alert('region')
    const auth = useAuthStore()
    auth.setBsw('0') // 戻るボタン制御用
    if (auth.token !== 'ok') {
      auth.setBsw('1') // 戻るボタン制御用
      this.$router.push('/')
    } else {
      if (auth.acceptflg !== '1') {
        auth.setBsw('1') // 戻るボタン制御用
        this.$router.push('/')
      } else {
        this.regionId = auth.region
        this.startDisplay()
      }
    }
  },
  methods: {
    async startDisplay () {
      // alert('startDisplay region')
      const auth = useAuthStore()
      axios.post('/api/region', {
        argtoken: auth.token,
        argacceptflg: auth.acceptflg
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            // auth.setToken('ok')
            // auth.setTermstext(this.results.termstext)
            // alert(JSON.stringify(this.results.datapref))
            this.cityData = JSON.parse(JSON.stringify(this.results.datacity))
            this.regionList = []
            var wkll = {}
            for (var cx = 0; cx < this.results.datapref.length; cx++) {
              wkll = {}
              wkll.title = this.results.datapref[cx].PREF_NM
              wkll.value = this.results.datapref[cx].PREF_NM
              this.regionList.push(wkll)
            }
            this.rigionData = []
            for (var cy = 0; cy < this.results.datarigion.length; cy++) {
              wkll = {}
              wkll.title = this.results.datarigion[cy].RIGION_NM
              wkll.value = this.results.datarigion[cy].RIGION_CD
              this.rigionData.push(wkll)
            }
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    prefChange () {
      // alert('change')
      this.cityList = []
      this.cityId = ''
      var wkll = {}
      for (var cx = 0; cx < this.cityData.length; cx++) {
        if (this.cityData[cx].PREF_CD === this.regionId) {
          wkll = {}
          wkll.title = this.cityData[cx].CITY_NM // + ' 地域コード : ' + this.cityData[cx].RIGION_CD
          // wkll.title = '123'
          wkll.value = this.cityData[cx].CITY_CD
          this.cityList.push(wkll)
        }
      }
      // alert(this.cityList[0].title)
    },
    cityChange () {
      for (var cx = 0; cx < this.cityData.length; cx++) {
        if (this.cityData[cx].CITY_CD === this.cityId) {
          this.rigionClass = this.cityData[cx].RIGION_CD
          break
        }
      }
    },
    async next () {
      const auth = useAuthStore()
      // 値の保存(common.js)
      auth.setBsw('1') // 戻るボタン制御用
      auth.setRegion(this.rigionClass)
      // window.currentId = '/products'
      this.$router.push('/products')
    },
    async backFnc () {
      const auth = useAuthStore()
      auth.setBsw('1') // 戻るボタン制御用
      this.$router.push('/terms')
    }
  }
}
</script>
<style scoped>
.list-container {
  display: flex; /* フレックスボックスでリストを横に並べる */
}
.list-box {
  border: 1px solid #ccc; /* 枠線の色とスタイルを設定 */
}
.scrollable-list {
  width: 400px; /* リストの幅を300pxに設定 */
  height: 250px; /* 高さを調整して10行分にします */
  overflow-y: auto; /* コンテンツが溢れた場合にスクロールバーを表示 */
  border: 1px solid #ccc; /* 枠線の色とスタイルを設定 */
  border-radius: 4px; /* 角を丸くするオプション */
}

.selected-item {
  background-color: #e0e0e0 !important; /* 選択されたアイテムの背景色 */
}
.v-list-item {
  cursor: pointer; /* アイテムにカーソルを合わせるとポインタが表示されるようにする */
}
.left-aligned {
  text-align: left; /* テキストを左寄せにする */
}
.custom-select {
  background-color: #ffffff; /* 背景色を設定 */
  border: 1px solid rgb(10, 10, 255); /* 枠線を設定 */
  border-radius: 4px; /* 角を丸くする */
  padding: 10px; /* 内側の余白を設定 */
  height: 28px;
}
</style>
